<template>
    <div>
        <div id="modal" class="modal is-active">
            <div class="modal-background"></div>
            <div class="modal-content">
                <div class="box">
                    <article class="media">
                        <div class="media-left">
                            <figure class="image is-64x64">
                                <img  :src="provider.logo"  alt="Image">
                            </figure>
                        </div>
                        <div class="media-content">
                            <div class="content">
                                <div>
                                    <h3 class="headline mb-0">{{ provider.name }}</h3>
                                    <div v-if="!call">Obteniendo información de la llamada espere...</div>
                                    <div v-if="callContext">Origen: {{ callContext.from }}</div>
                                </div>
                            </div>
                            <br>
                            <form v-if="onCall" @submit.prevent="hangup" ref="formcall">
                                <FormInput v-model="name"
                                           name="name"
                                           label="Nombre del cliente"
                                           required></FormInput>
                                <FormInput v-model="comments"
                                           name="comments"
                                           label="Commentarios"
                                           hint="Escribir comentarios adicionales durante la llamada"></FormInput>
                                <button type="submit" class="button is-success is-fullwidth">Terminar Llamada</button>
                            </form>
                            <br>
                            <form v-if="onCall" @submit.prevent="transfer" ref="formcall">
                                <div v-if="false" class="columns">
                                    <div class="column">
                                        <b-radio v-model="typeCall"
                                                 native-value="external">
                                            Externa
                                        </b-radio>
                                        <b-radio v-model="typeCall"
                                                 native-value="internal">
                                            Interna
                                        </b-radio>
                                    </div>
                                </div>
                                <div class="columns" v-if="typeCall === 'external'">
                                    <div class="column">
                                        <vue-tel-input v-model="to_phone_transfer"
                                                       defaultCountry="MX"
                                                       placeholder="Ingrese número telefónico"
                                                       :onlyCountries="countries"
                                                       :required="true"
                                                       :disabledFetchingCountry="true"
                                        >
                                        </vue-tel-input>
                                    </div>
                                </div>
                                <div class="columns" v-if="typeCall !== 'external'">
                                    <div class="column is-0">
                                        <b-select class="is-fullwidth" placeholder="Seleccionar operador" icon="account" required v-model="to_transfer">
                                            <option value="">Seleccionar ...</option>
                                            <optgroup
                                                v-for="provider_o in workers"
                                                :key="provider_o.id"
                                                :label="provider_o.name">
                                                <option
                                                    v-for="option in provider_o.workspace.workers"
                                                    v-if="showWorker(option)"
                                                    :value="option.id"
                                                    :key="option.id">
                                                    {{ option.user.profile.fullName }} - {{option.activity?option.activity.name:'Offline'}}
                                                </option>
                                            </optgroup>
                                        </b-select>
                                    </div>
                                </div>
                                <div class="columns">
                                    <div class="column is-12">
                                        <button type="submit" class="button is-primary is-fullwidth">Transferir Llamada</button>
                                    </div>
                                </div>

                            </form>
                            <br>
                            <a class="button is-primary is-fullwidth" @click.once="handleAcceptCall"  v-if="! onCall">Responder llamada</a>
                            <!--<a class="button is-secondary" @click.once="call.reject()"  v-if="! onCall">Rechazar llamada</a>-->
                        </div>
                    </article>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "IncomingModal",
        props:{
            call: Object,
            workers: Array
        },
        data() {
            return {
                provider: this.$auth.user().provider,
                onCall: false,
                typeCall: 'internal',
                comments: '',
                name: '',
                to_transfer: '',
                to_phone_transfer: '',
                countries: ['MX'],
            }
        },
        computed:{
            callContext() {
                return this.$store.state.currentCall;
            }
        },
        methods: {
            handleAcceptCall(){
                this.onCall = true;
                this.call.accept();
                this.$http.post('/ivr/answer-call').then(response=>{
                    console.log('call answer');
                });
            },
            hangup() {

                let data = {
                    comments: this.comments,
                    name: this.name,
                    call_sid: this.callContext? this.callContext.call_sid:''
                };
                this.$http.post('/ivr/update_call', data).then(response => {
                    this.$http.post('/ivr/hangup', {
                        call_sid: this.callContext? this.callContext.call_sid:'',
                        active_poll: true
                    }).then(response => {
                        this.$emit('hangup');
                        this.$store.commit('currentCall', null);
                    }).catch(error => {
                        this.$emit('hangup');
                        this.$store.commit('currentCall', null);
                    });
                });
            },
            transfer() {
                let data = {
                    comments: this.comments,
                    name: this.name,
                    call_sid: this.callContext? this.callContext.call_sid:''
                };
                console.log('call context sid :' + (this.callContext ? this.callContext.call_sid:''));
                this.$http.post('/ivr/update_call', data).then(response => {
                    data = {
                        to: this.typeCall === 'internal' ? this.to_transfer: this.to_phone_transfer,
                        call_sid: this.callContext? this.callContext.call_sid:'',
                        type: this.typeCall
                    };
                    this.$http.post('/ivr/transfer', data).then(response => {
                        this.$emit('hangup');
                    }).catch(error => {});
                });
            },
            showWorker(worker){
                return worker.user.id !== this.$auth.user().id;
            }
        }
    }
</script>

<style scoped>
    .modal .modal-content{
        width: 50%;
    }
</style>
